import { useLocalisedContent } from '@/redux/partnerConfig/selectors'
import { useActiveStepIndex } from '@/redux/signup/selectors'
import { Step, LocalisedContent } from '@/types/partnerConfig'

const usePageContent = (locale: string): Step => {
  const content: LocalisedContent = useLocalisedContent(locale)
  const activeStepIndex: number = useActiveStepIndex()

  return content.steps[activeStepIndex]
}

export default usePageContent
